<template>
  <div class="travelDetails">
    <Header></Header>
    <Nav></Nav>
    <div class="travelDetailsTitle">
      <h3>{{detailData.title}}</h3>
      <div class="travelDetailsTitle_text">
        <p>{{detailData.writetime}}  来源：{{detailData.authorname}}</p>
        <div>
          <span @click="zuanStatus()"><img src="../assets/static/images/travelDetailsIcon1.png" alt="" v-if="!iszan"><img src="../assets/static/images/travelDetailsIconon.png" alt="" v-if="iszan">{{detailData.zuan ? detailData.zuan : 0}}</span>
          <!-- <span><img src="../assets/static/images/travelDetailsIcon2.png" alt="">分享</span> -->
        </div>
      </div>
      <img src="../assets/static/images/footer-split.png" alt="">
    </div>
    <div class="travelDetails_c" v-html="detailData.content">
        
    </div>
    <div class="travelDetails_message">
      <h3>留言</h3>
      <div class="travelDetails_message_top">
        <img src="../assets/static/images/travelDetailsIcon3.png" alt="">
        <div class="travelDetails_message_right">
          <div class="textarea">
             <textarea name="" id="" v-model="content"></textarea>
          </div>
          <div class="travelDetails_message_button">
            <div class="travelDetails_message_button_left"></div>
            <div class="travelDetails_message_button_right">
              <router-link tag="span" to="login" v-if="!userinfoId">登录</router-link>
              <i v-if="!userinfoId"></i>
              <router-link tag="span" to="register"  v-if="!userinfoId">注册</router-link>
              <span class="release" @click="release()">发布</span>
            </div>
          </div>
        </div>
      </div>
      <div class="travelDetails_message_list">
          <div class="travelDetails_message_tit">最新留言</div>
          <div class="travelDetails_message_list_c" v-if="Leavinglist.length>0">
            <div class="travelDetails_message_item" v-for="(item,index) of Leavinglist" :key="index">
              <img :src="item.header" alt="">
              <div>
                <p class="title">{{item.username}}</p>
                <p class="text">{{item.content}}</p>
                <p class="time">发表于 {{item.leavetime}}</p>
              </div>
            </div>
          </div>
          <div class="travelDetails_message_list_c" v-else>
            <div class="null">暂无留言</div>
          </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
  import Header from './common/Header.vue'
  import Nav from './common/Nav.vue'
  import Footer from './common/Footer.vue'
  export default{
    data(){
      return{
        detailData:[],
        userinfoId:'',
        content:'',
        Leavinglist:'',
        iszan:false
      }
    },
    components:{
      Header,
      Footer,
      Nav,
    },
    computed: {
      
    },
    mounted(){
      if (localStorage.getItem('userInfoId')) {
        this.userinfoId = localStorage.getItem('userInfoId')
      }
      if (sessionStorage.getItem('userInfoId')) {
        this.userinfoId = sessionStorage.getItem('userInfoId')
      }
      this.getDetail()
      this.getListByArticleId()
    },
    methods:{
      getDetail(){
        this.axios.post('api/c_article/getDetail.do',this.qs({id:this.$route.query.id}))
        .then(res =>{
          res.data.data.writetime = this.$moment(res.data.data.writetime).format('YYYY-MM-DD HH:mm'),
           this.detailData = res.data.data
        })
      },
      //发布留言
      release(){        
        var json = {
          flag:0,
          id:'',
          targetid:this.$route.query.id,
          userid:this.userinfoId,
          content:this.content,
          type:this.$route.query.type,
        }
        if(!this.userinfoId){
          this.$message.error("请登录，再留言")
          return
        }
        if(!this.content){
          this.$message.error("留言内容不能为空")
          return
        }
        this.axios.post('api/c_comment/add.do',this.qs(json))
        .then(res =>{
          if(res.data.code == 0){
            this.$message.success("留言成功！等待审核")
            this.getListByArticleId()
          }else{
             this.$message.error("留言失败！")
          }
        })
      },
      //留言列表
      getListByArticleId(){
        this.axios.post('api/c_comment/getListByArticleId.do',this.qs({articleid:this.$route.query.id,pageNo:1,pageSize:9999}))
        .then(res =>{
          if(res.data.code==0){
            for(var i=0;i<res.data.page.results.length;i++){
              if(res.data.page.results[i].leavetime){
                 res.data.page.results[i].leavetime = this.$moment(res.data.page.results[i].leavetime).format('YYYY-MM-DD HH:mm')
              }             
            }
            this.Leavinglist = res.data.page.results
          }
        })
      },
      //点赞
      zuanStatus(){
        this.axios.post('api/c_article/zuan.do',this.qs({id:this.$route.query.id}))
        .then(res =>{
           if(res.data.code == 0){
             this.$message.success("点赞成功")
             this.iszuanStatus()
             this.getDetail()
           }
        })
      },
      //点赞状态
      iszuanStatus(){
        this.axios.post('api/c_article/zuanStatus.do',this.qs({id:this.$route.query.id}))
        .then(res =>{
           if(res.data.resultCode == 0){
             this.iszan = res.data.zuan
           }
        })
      },
    }
  }
</script>

<style>
</style>
